import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen } from '@fortawesome/pro-light-svg-icons/faBookOpen';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { TypedMemo } from '../../../common/types';
import { HELP_CENTER_URL, helpArticleUrl } from '../../../support/helpCenter/helpCenterUrl';
import { supportMessages } from './supportMessages';
import { Panel, PanelBody, PanelHead } from '../../../music24/components/primitives/Panel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Settings tabs; each part uses its own slice of it */
import styles from './support.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The help center articles behind the common questions (music24-website help/content). */
const TOPICS: { label: MessageDescriptor; category: string; article: string }[] = [
  { label: supportMessages.topicNoCode, category: 'troubleshooting', article: 'no-sign-in-code' },
  { label: supportMessages.topicPayment, category: 'troubleshooting', article: 'payment-or-plan-problem' },
  { label: supportMessages.topicPostFailed, category: 'troubleshooting', article: 'post-failed-to-publish' },
  { label: supportMessages.topicDataStale, category: 'troubleshooting', article: 'data-not-updating' },
  { label: supportMessages.topicSmartLink, category: 'troubleshooting', article: 'smartlink-not-working' },
  { label: supportMessages.topicCancel, category: 'billing', article: 'cancel' },
];

/** The help center and six common questions (design settings-redesign d1). */
const SupportHelpCardComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <Panel as="section">
      <PanelHead
        title={intl.formatMessage({ id: 'app.sml.settings.support.helpCenter', defaultMessage: 'Help center' })}
        subtitle={intl.formatMessage(supportMessages.helpCenterDescription)}
        right={
          <a
            className="btn btn-sm btn-outline-secondary"
            href={HELP_CENTER_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faBookOpen} className="me-2" />
            {intl.formatMessage(supportMessages.openHelpCenter)}
          </a>
        }
      />
      <PanelBody>
        <ul className={styles.topics} aria-label={intl.formatMessage(supportMessages.commonQuestions)}>
          {TOPICS.map((topic) => (
            <li key={topic.article}>
              <a
                className={styles.topic}
                href={helpArticleUrl(topic.category, topic.article)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>{intl.formatMessage(topic.label)}</span>
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </a>
            </li>
          ))}
        </ul>
      </PanelBody>
    </Panel>
  );
};

export const SupportHelpCard = TypedMemo(SupportHelpCardComponent);
